
import { defineComponent } from "vue";
import { Container, Section, Heading2 } from "@/components/layout";
import { Timeline } from "@/components/common";
import { useContent } from "@/hooks";

export default defineComponent({
  name: "Education",
  components: { Container, Section, Heading2, Timeline },
  setup() {
    const { degrees } = useContent();

    return { entities: degrees };
  },
});
